import { RootState } from "@/store/store";
import { dimensionSharedCostsSelector } from "@/store/dimensions/selectors/slice-data/shared-costs/dimensionSharedCostsSelector";

export const dimensionSharedCostsLengthSelector = (state: RootState) => {
  const costs = dimensionSharedCostsSelector(state);

  return costs.length;
};
